import { toast } from "sonner";

/**
 * Show a toast for each newly-unlocked achievement returned by the backend.
 * Call this with `response.new_achievements` after qualifying user actions.
 */
export function celebrateAchievements(newAchievements, lang = "ar") {
  if (!Array.isArray(newAchievements) || newAchievements.length === 0) return;
  for (const a of newAchievements) {
    const title = lang === "ar" ? a.title_ar : a.title_en;
    const desc = lang === "ar" ? a.desc_ar : a.desc_en;
    toast.success(`🏆 ${lang === "ar" ? "شارة جديدة:" : "New badge:"} ${title}`, {
      description: desc,
      duration: 5000,
    });
  }
}
